import { View, type StyleProp, type ViewStyle } from "react-native";
import Svg, { Path, Pattern, Rect } from "react-native-svg";

import { useTheme } from "~/styles/theme";

/**
 * The shared "workshop blueprint" motif — a faint technical grid. The marketing
 * site draws the same thing in CSS; keeping both in step is what makes the app
 * and the website read as one product.
 */
export function BlueprintGrid({
  tone = "paper",
  size = 26,
  style,
}: {
  tone?: "paper" | "steel";
  size?: number;
  style?: StyleProp<ViewStyle>;
}) {
  const { colors } = useTheme();
  const fine =
    tone === "steel" ? "rgba(244, 241, 234, 0.055)" : "rgba(28, 35, 33, 0.045)";
  const bold =
    tone === "steel" ? "rgba(232, 168, 56, 0.11)" : "rgba(61, 90, 128, 0.08)";
  const block = size * 5;

  return (
    <View pointerEvents="none" style={style}>
      <Svg width="100%" height="100%">
        <Rect
          x={0}
          y={0}
          width="100%"
          height="100%"
          fill={tone === "steel" ? colors.steel : colors.background}
        />
        <Pattern
          id="blueprint-grid"
          width={block}
          height={block}
          patternUnits="userSpaceOnUse"
        >
          {Array.from({ length: 5 }, (_, i) => (
            <Path
              key={`h${i}`}
              d={`M0 ${i * size} H ${block}`}
              stroke={fine}
              strokeWidth={1}
            />
          ))}
          {Array.from({ length: 5 }, (_, i) => (
            <Path
              key={`v${i}`}
              d={`M${i * size} 0 V ${block}`}
              stroke={fine}
              strokeWidth={1}
            />
          ))}
          <Path d={`M0 0 H ${block}`} stroke={bold} strokeWidth={1.25} />
          <Path d={`M0 0 V ${block}`} stroke={bold} strokeWidth={1.25} />
        </Pattern>
        <Rect
          x={0}
          y={0}
          width="100%"
          height="100%"
          fill="url(#blueprint-grid)"
        />
      </Svg>
    </View>
  );
}
